import React from "react";
//Material UI
import { IconButton } from "@mui/material";
//Icons
import AttachFileIcon from "@mui/icons-material/AttachFile";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const Footer = () => {
  return (
    <div className="max-w-[1146px] mx-auto md:px-0 px-4">
      <div className="pb-16 pt-8 md:py-16 space-y-8 flex flex-col md:flex-row items-center justify-between">
        <div className="flex space-x-1 items-center justify-center">
          <a
            href="https://drive.google.com/file/d/1QJ-eS1uU6oJbuDWotwkLCXzylThb0MXu/view"
            target="_blank"
            rel="noreferrer"
            data-umami-event="clicked-cv-block"
          >
            <IconButton>
              <AttachFileIcon className=" hover-icon-animation" />
            </IconButton>
          </a>
          <a
            href="mailto:badreddin.labed@mindera.com"
            target="_blank"
            rel="noreferrer"
            data-umami-event="clicked-mail-block"
          >
            <IconButton>
              <EmailIcon className=" hover-icon-animation" />
            </IconButton>
          </a>
          <a
            href="https://www.linkedin.com/in/badreddin-labed/"
            target="_blank"
            rel="noreferrer"
            data-umami-event="clicked-linkedin-block"
          >
            <IconButton>
              <LinkedInIcon className=" hover-icon-animation" />
            </IconButton>
          </a>
        </div>
        <div className="text-sm font-normal leading-loose opacity-60 text-center space-x-1">
          <span>All rights reserved to</span>
          <span className="text-primary-color">Badreddin Labed</span>
          <span>© 2019-{new Date().getFullYear()}</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
